import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { FILTER_TYPE_META } from '../../../../constants/reviewEntriesFilterConfig'
import { ReviewEntriesFilterType } from '../../../../enums/reviewEntriesFilterType'
import type { ReviewEntriesAmountRangeFilter, ReviewEntriesFiltersState } from '../../../../types/reviewEntriesFilters'
import { formatReviewEntriesFilterPreview } from '../../../../utils/formatReviewEntriesFilterPreview'
import { isAmountRangeFilterEmpty } from '../../../../utils/isReviewEntriesFilterValueEmpty'
import { AmountRangeFilterBody } from '../../elements/AmountRangeFilterBody'
import { ReviewEntriesFilterChipShell } from '../../ReviewEntriesFilterChipShell'

interface AmountRangeFilterChipProps {
  type: ReviewEntriesFilterType.ExclVat | ReviewEntriesFilterType.InclVat
  filters: ReviewEntriesFiltersState
  shouldAutoOpen: boolean
  onAutoOpenHandled: () => void
  onDelete: () => void
  onReset: () => void
  onChange: (range: ReviewEntriesAmountRangeFilter | undefined) => void
}

export const AmountRangeFilterChip = ({
  type,
  filters,
  shouldAutoOpen,
  onAutoOpenHandled,
  onDelete,
  onReset,
  onChange,
}: AmountRangeFilterChipProps): ReactElement => {
  const { t } = useTranslation()
  const range = filters[type]
  const label = t(FILTER_TYPE_META[type].labelKey)

  return (
    <ReviewEntriesFilterChipShell
      isActive={!isAmountRangeFilterEmpty(range)}
      label={label}
      onAutoOpenHandled={onAutoOpenHandled}
      onDelete={onDelete}
      onReset={onReset}
      shouldAutoOpen={shouldAutoOpen}
      type={type}
      valuePreview={formatReviewEntriesFilterPreview(type, filters)}
    >
      <AmountRangeFilterBody
        onChange={(nextRange) => {
          if (isAmountRangeFilterEmpty(nextRange)) {
            onChange(undefined)
            return
          }

          onChange(nextRange)
        }}
        range={range}
      />
    </ReviewEntriesFilterChipShell>
  )
}
